import { Component, OnInit, Output } from '@angular/core';

import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-estado-popover',
  templateUrl: './estado-popover.component.html',
  styleUrls: ['./estado-popover.component.scss'],
})
export class EstadoPopoverComponent implements OnInit {

  @Output() option;

  estados: string[];

  constructor(private popoverController: PopoverController) {
    this.estados = [
      'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Ciudad de México',
      'Chiapas', 'Chihuahua', 'Coahuila', 'Colima', 'Durango', 'Guanajuato',
      'Guerrero', 'Hidalgo', 'Jalisco', 'México', 'Michoacán', 'Morelos',
      'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo',
      'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala',
      'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'
    ];
  }

  ngOnInit() { }

  getOption(estado) {
    console.log('Opción elegida(lado del hijo):', estado);
    this.option = estado;
    this.popoverController.dismiss(this.option);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

}
